module.exports = __webpack_public_path__ + "static/garantie-15-7bf4ad4b0d6619cb71d3ed03c7675137.svg";